import request from '../utils/request'
import {
    assignKeysA
} from '../utils/index';
// 广告主用户登录
const baseUrl_ad = process.env.NODE_ENV === "production"?'http://iadvertiser.shareclick.top/':'http://118.31.247.151:18120/'
export function advertiserPostLogin(param) {
    console.log(param)
    return request({
        url: `${baseUrl_ad}/api/login/login`,
        method: 'post',
        data: assignKeysA({}, [param], ['account', 'password'])
    });
}
//媒体登录
const baseUrl_mj = process.env.NODE_ENV === "production"?'http://imedia.shareclick.top/':'http://118.31.247.151:18220/'
export function mediaPostLogin(param) {
    return request({
        url: `${baseUrl_mj}/api/login/login`,
        method: 'post',
        data: assignKeysA({}, [param], ['account', 'password'])
    });
}